export function initQuantityCounter() {
  jQuery(".increment").on("click", function (e) {
    e.preventDefault();
    const $input = jQuery(this).siblings(".quantity-input");
    const currentVal = parseInt($input.val());
    if (!isNaN(currentVal)) {
      $input.val(currentVal + 1);
    }
  });

  jQuery(".decrement").on("click", function (e) {
    e.preventDefault();
    const $input = jQuery(this).siblings(".quantity-input");
    const currentVal = parseInt($input.val());
    if (!isNaN(currentVal) && currentVal > 1) {
      $input.val(currentVal - 1);
    }
  });
}

export function initAjaxAddToCart() {
  jQuery(".add-to-cart-btn").on("click", function (e) {
    e.preventDefault();
    const button = jQuery(this);
    const productId = button.data("product-id");
    const quantity =
      button.closest(".product-box").find(".quantity-input").val() || 1;

    // 1) adiciona ao carrinho
    jQuery
      .post(
        wc_add_to_cart_params.wc_ajax_url.replace(
          "%%endpoint%%",
          "add_to_cart"
        ),
        { product_id: productId, quantity: quantity }
      )
      .done(function (res) {
        if (res.error) {
          console.error(res);
          return;
        }
        console.log("Produto adicionado com sucesso!");

        (function ($) {
          const fragUrl = wc_cart_fragments_params.wc_ajax_url
            .toString()
            .replace("%%endpoint%%", "get_refreshed_fragments");

          $.post(
            fragUrl,
            {},
            function (frag) {
              if (frag && frag.fragments) {
                $.each(frag.fragments, function (selector, html) {
                  $(selector).replaceWith(html);
                });
              }
            },
            "json"
          );
        })(jQuery);
      })
      .fail(function (err) {
        console.error("Erro na requisição", err);
      });
  });
}

export function initCartBadge() {
  const badge = document.getElementById("cartBadge");
  if (!badge || typeof wc_cart_fragments_params === "undefined") return;

  const updateBadge = (count) => {
    badge.textContent = count;
    count > 0 ? badge.classList.remove("hidden") : badge.classList.add("hidden");
  };

  const fetchCartCount = () => {
    jQuery.post(
      wc_cart_fragments_params.wc_ajax_url.toString().replace("%%endpoint%%", "get_refreshed_fragments"),
      {},
      function (res) {
        if (res && typeof res.cart_item_count !== "undefined") {
          updateBadge(parseInt(res.cart_item_count));
        }
      },
      "json"
    );
  };

  jQuery(document.body).on("wc_fragments_refreshed wc_fragments_loaded added_to_cart removed_from_cart updated_cart_totals", fetchCartCount);
}

export function initBestSellerTemplate() {
  initQuantityCounter();
  initAjaxAddToCart();
}
